export const interiors = ({ interiors }) => interiors.byId;
